import React from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Grid } from 'react-md'

import { handleSubmit, InputNumber } from 'components/form'
import { Modal } from 'components/core'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

interface ComponentProps {
  maintenanceScheduleId: string
  actionId: string | null | undefined
  visibleModal: boolean
  disableModal: () => void
  loadMaintenanceSchedule: () => Promise<void>
  onHide: () => void
}

const Component: React.FC<ComponentProps> = ({ maintenanceScheduleId, actionId, visibleModal, disableModal, loadMaintenanceSchedule, onHide }) => {
  const form = useForm({ defaultValues })

  return (
    <Modal
      width={300}
      title={'Subtração de Horas'}
      visible={visibleModal}
      confirmTitle={'Salvar'}
      confirmDisabled={!form.formState.dirty}
      confirmAction={async () => {
        await handleSubmit(form, validationSchema, async () => {
          await handleSave({ maintenanceScheduleId, id: actionId, ...form.getValues() })
          form.reset(defaultValues, { dirty: false })
          await loadMaintenanceSchedule()
          onHide()
          disableModal()
        })
      }}
      closeTitle={'Fechar'}
      closeAction={async () => {
        form.reset(defaultValues, { dirty: false })
        onHide()
        disableModal()
      }}>
      <Grid>
        <FormContext {...form}>
          <InputNumber name='hours' label='Quantidade de Horas *' desktopSize={12} tabletSize={8} />
        </FormContext>
      </Grid>
    </Modal>
  )
}

export default Component
